import rdylbudata from "./raw/rdylbu.json";

export const RdYlBuColorMap = (type) => {
  if (type === "range") {
    return rdylbudata;
  }
};
